import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';

const Home: React.FC = () => {
  return (
    <div className="home">
      <div className="hero">
        <h1>Welcome to SCL Networks</h1>
        <p>Your Trusted Partner in Web Development and Digital Solutions</p>
        <Link to="/contact" className="cta-button">Get Started</Link>
      </div>

      <section className="services-preview">
        <h2>Our Services</h2>
        <div className="services-grid">
          <div className="service-card">
            <i className="fas fa-code"></i>
            <h3>Web Development</h3>
            <p>Custom web solutions tailored to your business needs</p>
          </div>
          <div className="service-card">
            <i className="fas fa-mobile-alt"></i>
            <h3>Responsive Design</h3>
            <p>Mobile-first websites that work on all devices</p>
          </div>
          <div className="service-card">
            <i className="fas fa-shopping-cart"></i>
            <h3>E-Commerce</h3>
            <p>Online store development and management</p>
          </div>
        </div>
        <Link to="/services" className="learn-more">Learn More</Link>
      </section>

      <section className="why-choose-us">
        <h2>Why Choose SCL Networks?</h2>
        <div className="features-grid">
          <div className="feature">
            <i className="fas fa-check-circle"></i>
            <h3>Expert Team</h3>
            <p>Skilled developers with years of experience</p>
          </div>
          <div className="feature">
            <i className="fas fa-clock"></i>
            <h3>Timely Delivery</h3>
            <p>We deliver projects on time, every time</p>
          </div>
          <div className="feature">
            <i className="fas fa-headset"></i>
            <h3>24/7 Support</h3>
            <p>Round-the-clock technical support</p>
          </div>
          <div className="feature">
            <i className="fas fa-dollar-sign"></i>
            <h3>Competitive Pricing</h3>
            <p>Best value for your investment</p>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to Start Your Project?</h2>
        <p>Let's discuss how we can help you achieve your goals</p>
        <Link to="/contact" className="cta-button">Contact Us</Link>
      </section>
    </div>
  );
};

export default Home; 